// Vendors
import { TweenMax, TimelineMax, Power0, Power2 } from "gsap/TweenMax";
import "./../vendors/gsap/src/bonus-files-for-npm-users/MorphSVGPlugin";

// Utilities
import Config from "../constants/Config";
import { qs, cls } from "./util/dom-utils";
import pubsub from "./util/pubsub";

class Loader {
    constructor(el) {
        this.$el = el;

        this.$itemLeft = qs(".shape-item--left", this.$el);
        this.$itemRight = qs(".shape-item--right", this.$el);
        this.$shapeLeft = qs("svg", this.$itemLeft);
        this.$shapeRight = qs("svg", this.$itemRight);
        this.$pathLeft = qs("path", this.$shapeLeft);
        this.$pathRight = qs("path", this.$shapeRight);
        this.$preloader = qs('.preloader', this.$el);
        this.$shapeLeft.style.transformOrigin = "0% 50%";
        this.$shapeRight.style.transformOrigin = "100% 50%";

        const timeout = 3000;

        this.isLoading = true;
        cls.add(Config.$body, Config.classes.NO_SCROLL);

        this.animation();

        setTimeout(() => {
            this.tl.play();
        }, timeout);
    }

    animation() {
        
        window.addEventListener("load", (event) => {
			this.$el.removeChild(this.$preloader);
        });
        
        this.tl = new TimelineMax({
            paused: true,
            onComplete: () => {
                this.$el.parentNode.removeChild(this.$el);
                cls.add(Config.$body, Config.classes.LOADED);
                cls.remove(Config.$body, Config.classes.NO_SCROLL);

                pubsub.publish(Config.events.LOADER_GONE);
            }

        });


        this.tl.add([
            TweenMax.to(".loader__gif", 1, {
                opacity: 0
            }),
        ])
        this.tl.add([
            TweenMax.to(this.$itemLeft, 2, {
                xPercent: -110,
                ease: Power2.easeIn
            }),

            TweenMax.to(this.$itemRight, 2, {
                xPercent: 110,
                ease: Power2.easeIn,
                onUpdate: () => {
                    pubeventFn();
                }
            }),

            TweenMax.to(this.$shapeLeft, 2, {
                scaleY: 5,
                ease: Power2.easeIn
            }),

            TweenMax.to(this.$shapeRight, 2, {
                scaleY: 5,
                ease: Power2.easeIn
            }),

            TweenMax.to(this.$pathLeft, 1, {
                morphSVG: this.$pathLeft.getAttribute("pathdata"),
                ease: Power0.easeOut,
                delay: 0.3
            }),

            TweenMax.to(this.$pathRight, 1, {
                morphSVG: this.$pathRight.getAttribute("pathdata"),
                ease: Power0.easeOut,
                delay: 0.3
            })
        ]);

        const pubeventFn = () => {
            let time = Math.round(this.tl.time() * 10) / 10;
            if (time === 2.6) {
                pubsub.publish(Config.events.LOADER_EXIT);
            }

        }
    }
}

export default Loader;

const _init = () => {

    // Elements
    let $el = qs(".loader");

    if ($el) {
        new Loader($el);
    }
};

_init();
